import { render, staticRenderFns } from "./propertyManagementModel.vue?vue&type=template&id=f9d45d7c"
import script from "./propertyManagementModel.vue?vue&type=script&lang=js"
export * from "./propertyManagementModel.vue?vue&type=script&lang=js"
import style0 from "./propertyManagementModel.vue?vue&type=style&index=0&id=f9d45d7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports